export function addToArray(values, diff) {
  return values.map((value) => value + diff)
}

export function widenRange(values, diff) {
  return [values[0] - diff, values[1] + diff]
}
